export default __webpack_public_path__ + "static/media/Meri.6012f671.PNG";